module.exports = {
    RECIEPT     : "loan_reciept",
    REPAYMENT   : "loan_repayment",
    CLOSE       : "loan_close",
};